import { RxDimensions } from "react-icons/rx";
import { useState, useEffect } from "react";
import currency from "../../../utils/currencyConstants";
import api from "api/api";
import { ApiResponse } from "model/apiResponseModel";
import Grid from "@mui/material/Grid";
import { useLocation, useNavigate } from "react-router-dom";
import SoftBox from "components/SoftBox";
import CircularProgress from "@mui/material/CircularProgress";
import { Card } from "@mui/material";
import { ProjectsList } from "model/projectListModel";
import SoftTypography from "components/SoftTypography";
import TextareaAutosize, {
  TextareaAutosize as BaseTextareaAutosize,
} from "@mui/base/TextareaAutosize";
import {
  Box,
  TextField,
  Button,
  IconButton,
  styled,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Chip,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import SoftButton from "components/SoftButton";
import AddIcon from "@mui/icons-material/Add";
import { useOutletContext } from "react-router-dom";

const FormContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  width: "100%",
  maxWidth: "800px",
  margin: "0 auto",
}));

const FormField = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  width: "100%",
  "& .MuiTextField-root": {
    "& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button":
      {
        "-webkit-appearance": "none",
        margin: 0,
      },
  },
  "& .MuiInputAdornment-root": {
    marginLeft: "0px",
    paddingRight: "0px",
  },
}));

const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  width: "100%",
  minHeight: "200px",
  padding: "8px 12px",
  borderRadius: "8px",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  fontFamily: "inherit",
  fontSize: "14px",
  resize: "vertical",
  backgroundColor: "#f8f9fa",
  "&:focus": {
    outline: "none",
    borderWidth: "2px",
  },
  "&::placeholder": {
    color: "rgba(0, 0, 0, 0.42)",
  },
}));

export default function EditProject() {
  const location = useLocation();
  const navigate = useNavigate();
  // const queryParams = new URLSearchParams(location.search);
  // const projectId = queryParams.get("projectId");
  const { projectId } = useOutletContext();
  const [isLoading, setIsLoading] = useState(true);
  const [tag, setTag] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [localImage, setLocalImages] = useState([]);
  const [formData, setFormData] = useState({
    design: "",
    image: [],
    project_id: "",
    artist: "",
    brand: "",
    canvas_width: 0,
    canvas_height: 0,
    diamond_type: "",
    no_of_color: "",
    abs: 0,
    glow: 0,
    crystal: 0,
    dreamerDust: 0,
    special_status: false,
    country_code: "",
    currency_code: "",
    total_amount_diamonds: 0,
    price: 0,
    extraNotes: "",
    startDate: "",
    endDate: "",
    tags: [],
    isAdminVerified: false,
  });

  useEffect(() => {
    const loginData = JSON.parse(
      localStorage.getItem("loginData") || sessionStorage.getItem("loginData")
    );
    if (!loginData) {
      navigate("/authentication/sign-in");
    } else {
      fetchProjectDetail();
    }
  }, [projectId]);

  const fetchProjectDetail = async () => {
    try {
      setIsLoading(true);
      const projectData = { projectId: projectId };
      const response = await api.getProjectsDetail(projectData);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        const projectDetail = new ProjectsList(response.data);
        setLocalImages(projectDetail.image);

        setFormData({
          design: projectDetail.design,
          project_id: projectId,
          image: projectDetail.image,
          artist: projectDetail.artist,
          brand: projectDetail.brand,
          canvas_width: projectDetail.canvas_width,
          canvas_height: projectDetail.canvas_height,
          diamond_type: projectDetail.diamond_type,
          no_of_color: projectDetail.no_of_color,
          abs: projectDetail.abs,
          glow: projectDetail.glow,
          crystal: projectDetail.crystal,
          dreamerDust:projectDetail.dreamerDust,
          special_status: Boolean(projectDetail.abs || projectDetail.glow || projectDetail.crystal),
          country_code: projectDetail.country_code,
          currency_code: projectDetail.currency_code,
          total_amount_diamonds: projectDetail.total_amount_diamonds,
          price: parseFloat(projectDetail.price),
          extraNotes: projectDetail.extraNotes,
          startDate: projectDetail.startDate,
          endDate: projectDetail.endDate,
          tags: projectDetail.tags || [],
          isAdminVerified: projectDetail.isAdminVerified,
        });
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error fetching project detail:", error);
      alert("Error fetching project details");
    } finally {
      setIsLoading(false);
    }
  };

  const UploadBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(3),
    backgroundColor: "#f8f3ff",
    borderRadius: theme.shape.borderRadius,
    border: "1px dashed rgba(0, 0, 0, 0.12)",
    "&:hover": {
      backgroundColor: "#f8f3ff",
    },
  }));

  const HiddenInput = styled("input")({
    display: "none",
  });

  const handleTagChange = (e) => {
    setTag(e.target.value);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          image: [...prevFormData.image, file],
        }));
        setLocalImages((prevImages) => [...prevImages, e.target.result]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddProject = async (event) => {
    event.preventDefault();
    try {
      setIsLoading(true);
      const dataToSend = {
        ...formData,
        image: formData.image.filter((img) => img),
      };
      const response = await api.editProject(dataToSend);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        navigate(`/project-detail?projectId=${projectId}`, {
          state: { refresh: true }
        });
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error updating project:", error);
      alert("Error updating project");
    } finally {
      setIsLoading(false);
    }
  };

  const addTag = (e) => {
    e.preventDefault();
    if (tag.trim() === "") return;
    setFormData((prevFormData) => ({
      ...prevFormData,
      tags: [...prevFormData.tags, tag.trim()],
    }));
    setTag("");
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "currency_code") {
      const selectedElement = currency.find((currency) => currency.currency_code === value);

      if (selectedElement) {
        setFormData((prev) => ({
          ...prev,
          country_code: selectedElement.country_code,
          [name]: value,
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          image: [...prevFormData.image, file],
        }));
        setLocalImages((prevImages) => [...prevImages, e.target.result]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveTag = (indexToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      tags: prevFormData.tags.filter((_, index) => index !== indexToRemove),
    }));
  };

  const uploadImageClick = (e) => {
    e.preventDefault();
    document.getElementById("imageUploadInput").click();
  };

  return (
    <>
      <SoftBox p={3} pl={0}>
        <Card>
          <SoftBox p={3}>
            <SoftTypography variant="h5" mb={3}>
              Edit Project
            </SoftTypography>

            {isLoading ? (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
              </Box>
            ) : (
              <Grid container spacing={3}>
                {/* Image Upload Section */}

                <Grid item xs={12} md={6}>
                  <UploadBox onDrop={handleDrop} onDragOver={(e) => e.preventDefault()}>
                    {localImage.length > 0 && (
                      <>
                        <ImageSlider images={localImage} />
                        <Box textAlign="center">
                          <SoftTypography variant="h6" mb={1} mt={2}>
                            Drag or Upload Design Image
                          </SoftTypography>
                          <SoftTypography variant="body2" color="text.secondary" mb={2}>
                            Four images max. Up to 5MB and in png and jpg only
                          </SoftTypography>
                          <SoftButton variant="contained" onClick={uploadImageClick}>
                            Upload Image
                          </SoftButton>
                          <HiddenInput
                            type="file"
                            id="imageUploadInput"
                            accept="image/png, image/jpeg"
                            onChange={handleFileChange}
                          />
                        </Box>
                      </>
                    )}
                  </UploadBox>

                  <Box mt={3}>
                    <SoftTypography variant="caption" fontWeight="bold" mb={1}>
                      Extra Notes:
                    </SoftTypography>
                    <StyledTextarea
                      name="extraNotes"
                      value={formData.extraNotes}
                      onChange={handleChange}
                      placeholder="Extra Notes"
                      minRows={1}
                      maxRows={1}
                    />
                  </Box>
                </Grid>

                {/* Project Details Form */}
                <Grid item xs={12} md={6}>
                  <form onSubmit={handleAddProject}>
                    <FormContainer>
                      {/* Design Field */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="140px"
                          textAlign="right"
                        >
                          Design:
                        </SoftTypography>
                        <TextField
                          fullWidth
                          name="design"
                          value={formData.design}
                          onChange={handleChange}
                          required
                          variant="outlined"
                        />
                      </FormField>

                      {/* Artist Field */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="140px"
                          textAlign="right"
                        >
                          Artist:
                        </SoftTypography>
                        <TextField
                          fullWidth
                          name="artist"
                          value={formData.artist}
                          onChange={handleChange}
                          required
                          variant="outlined"
                        />
                      </FormField>

                      {/* Brand Field */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="140px"
                          textAlign="right"
                        >
                          Brand:
                        </SoftTypography>
                        <TextField
                          fullWidth
                          name="brand"
                          value={formData.brand}
                          onChange={handleChange}
                          required
                          variant="outlined"
                        />
                      </FormField>

                      {/* Canvas Size Fields */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="105px"
                          textAlign="right"
                        >
                          Canvas Size (CM):
                        </SoftTypography>
                        <Grid container spacing={2} sx={{ flex: 1 }}>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              type="number"
                              name="canvas_width"
                              placeholder="Width"
                              value={formData.canvas_width === 0 ? "" : formData.canvas_width}
                              onChange={handleChange}
                              required
                              variant="outlined"
                              InputProps={{
                                endAdornment: <RxDimensions />,
                              }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              type="number"
                              name="canvas_height"
                              placeholder="Height"
                              value={formData.canvas_height === 0 ? "" : formData.canvas_height}
                              onChange={handleChange}
                              required
                              variant="outlined"
                              InputProps={{
                                endAdornment: <RxDimensions />,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </FormField>

                      {/* Diamond Info Fields */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="105px"
                          textAlign="right"
                        >
                          Diamond Info:
                        </SoftTypography>
                        <Grid container spacing={2} sx={{ flex: 1 }}>
                          <Grid item xs={6}>
                            <FormControl fullWidth size="small">
                              <Select
                                name="diamond_type"
                                value={formData.diamond_type}
                                onChange={handleChange}
                                required
                                displayEmpty
                                sx={{
                                  backgroundColor: "#F3F3F3",
                                }}
                              >
                                <MenuItem value="">Shape</MenuItem>
                                <MenuItem value="square">Square</MenuItem>
                                <MenuItem value="round">Round</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              type="number"
                              name="no_of_color"
                              placeholder="No. of Colours"
                              value={formData.no_of_color}
                              onChange={handleChange}
                              required
                              variant="outlined"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#F3F3F3",
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </FormField>

                      {/* Special Diamonds Checkbox */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="85px"
                          textAlign="right"
                        ></SoftTypography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="special_status"
                              checked={formData.special_status}
                              onChange={handleChange}
                            />
                          }
                          label="Add Special Diamonds"
                        />
                      </FormField>

                      {/* Special Diamonds Fields */}
                      {formData.special_status && (
                        <FormField>
                          <SoftTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            width="105px"
                            textAlign="right"
                          ></SoftTypography>
                          <Grid container spacing={2} sx={{ flex: 1 }}>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                type="number"
                                name="abs"
                                placeholder="AB's"
                                value={formData.abs === 0 ? "" : formData.abs}
                                onChange={handleChange}
                                variant="outlined"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#F3F3F3",
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                type="number"
                                name="glow"
                                placeholder="Glow"
                                value={formData.glow === 0 ? "" : formData.glow}
                                onChange={handleChange}
                                variant="outlined"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#F3F3F3",
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                type="number"
                                name="crystal"
                                placeholder="Crystal"
                                value={formData.crystal === 0 ? "" : formData.crystal}
                                onChange={handleChange}
                                variant="outlined"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#F3F3F3",
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                type="number"
                                name="dreamerDust"
                                placeholder="Dreamer Dust"
                                value={formData.dreamerDust === 0 ? "" : formData.dreamerDust}
                                onChange={handleChange}
                                variant="outlined"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#F3F3F3",
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </FormField>
                      )}

                      {/* Total Amount of Diamonds */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="140px"
                          textAlign="right"
                        >
                          Total Amount of Diamonds:
                        </SoftTypography>
                        <TextField
                          fullWidth
                          type="number"
                          name="total_amount_diamonds"
                          value={
                            formData.total_amount_diamonds === 0
                              ? ""
                              : formData.total_amount_diamonds
                          }
                          onChange={handleChange}
                          required
                          variant="outlined"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "#F3F3F3",
                            },
                          }}
                        />
                      </FormField>

                      {/* Price and Currency */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="105px"
                          textAlign="right"
                        >
                          Price:
                        </SoftTypography>
                        <Grid container spacing={2} sx={{ flex: 1 }}>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              type="number"
                              name="price"
                              value={formData.price}
                              onChange={handleChange}
                              required
                              variant="outlined"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#F3F3F3",
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormControl fullWidth size="small">
                              <Select
                                name="currency_code"
                                value={formData.currency_code}
                                onChange={handleChange}
                                variant="outlined"
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 300,
                                      position: "absolute",
                                    },
                                  },
                                  anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                }}
                                sx={{
                                  backgroundColor: "#F3F3F3",
                                  "& .MuiMenuItem-root.Mui-selected": {
                                    backgroundColor: "transparent",
                                  },
                                  "& .MuiMenuItem-root:hover": {
                                    backgroundColor: "#f5f5f5",
                                  },
                                }}
                              >
                                <MenuItem value="">Select Currency</MenuItem>
                                {currency.map((singleCurrency) => (
                                  <MenuItem
                                    key={`${singleCurrency.currency_code}-${singleCurrency.country_code}`}
                                    value={singleCurrency.currency_code}
                                  >
                                    {singleCurrency.flag} {singleCurrency.currency_code}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </FormField>

                      {/* Start and End Date */}
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="105px"
                          textAlign="right"
                        >
                          Start and End date:
                        </SoftTypography>
                        <Grid container spacing={2} sx={{ flex: 1 }}>
                          <Grid item xs={6}>
                            <input
                              type="date"
                              name="startDate"
                              value={formData.startDate}
                              onChange={handleChange}
                              style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "8px",
                                fontFamily: "Roboto",
                                color: "#4f555c",
                              }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <input
                              type="date"
                              name="endDate"
                              value={formData.endDate}
                              onChange={handleChange}
                              style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "8px",
                                fontFamily: "Roboto",
                                color: "#4f555c",
                              }}
                            />
                          </Grid>
                        </Grid>
                      </FormField>

                      {/* Tags */}
                      <FormField sx={{ alignItems: "flex-start" }}>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="105px"
                          textAlign="right"
                          mt={2}
                        >
                          Tags:
                        </SoftTypography>
                        <Box sx={{ flex: 1 }}>
                          <Box display="flex" gap={1} mb={2}>
                            <TextField
                              fullWidth
                              name="tags"
                              value={tag}
                              onChange={handleTagChange}
                              variant="outlined"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  backgroundColor: "#F3F3F3",
                                },
                              }}
                            />
                            <IconButton
                              onClick={addTag}
                              sx={{
                                backgroundColor: "primary.main",
                                color: "#ffffff",
                                borderRadius: "80px",
                                width: "28px",
                                height: "28px",
                                "&:hover": {
                                  backgroundColor: "primary.main",
                                },
                                marginTop: "5px",
                              }}
                            >
                              <AddIcon />
                            </IconButton>
                          </Box>
                          <Box display="flex" flexWrap="wrap" gap={1}>
                            {formData.tags.map((tag, index) => (
                              <Chip
                                key={index}
                                label={tag}
                                onDelete={() => handleRemoveTag(index)}
                                sx={{ backgroundColor: "#F3F3F3" }}
                              />
                            ))}
                          </Box>
                        </Box>
                      </FormField>

                      {/* Admin Verification Checkbox
                      <FormField>
                        <SoftTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                          width="85px"
                          textAlign="right"
                        ></SoftTypography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="isAdminVerified"
                              checked={formData.isAdminVerified}
                              onChange={handleChange}
                            />
                          }
                          label="Admin Verified"
                        />
                      </FormField> */}

                      {/* Submit Button */}
                      <Box display="flex" justifyContent="flex-end" mt={3}>
                        <SoftButton
                          type="submit"
                          variant="contained"
                          color="primary"
                          sx={{ width: "250px" }}
                        >
                          Save Changes
                        </SoftButton>
                      </Box>
                    </FormContainer>
                  </form>
                </Grid>
              </Grid>
            )}
          </SoftBox>
        </Card>
      </SoftBox>
    </>
  );
}

const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="slider-container" style={{ color: "black !important" }}>
      <img
        src={images[currentIndex]}
        alt={`slide_${currentIndex}`}
        className="slider-image"
        style={{
          maxWidth: "300px", // Decreased from default
          maxHeight: "300px", // Decreased from default
          width: "auto",
          height: "auto",
          objectFit: "contain",
          margin: "0 auto",
          display: "block",
        }}
      />
      <div
        className="thumbnails-container"
        style={{ marginTop: "10px", display: "flex", gap: "8px", justifyContent: "center" }}
      >
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`thumbnail_${index}`}
            className={`thumbnail-image ${currentIndex === index ? "active" : ""}`}
            style={{
              width: "40px", // Decreased from 50px
              height: "40px", // Decreased from 50px
              objectFit: "cover",
              cursor: "pointer",
              border: currentIndex === index ? "2px solid #1A73E8" : "2px solid transparent",
            }}
            onClick={() => handleThumbnailClick(index)}
          />
        ))}
      </div>
    </div>
  );

  ImageSlider.propTypes = {
    images: PropTypes.array.isRequired,
  };
};
